module.exports = __webpack_public_path__ + "img/D.0ee064d4.svg";